/* eslint-disable multiline-ternary */
import isEmpty from 'lodash/isEmpty';
import { NextPage } from 'next';
import dynamic from 'next/dynamic';
import { NextRouter, useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { FaCaretRight, FaGripHorizontal, FaTimes } from 'react-icons/fa';
import { FaAngleDown } from 'react-icons/fa';
import { SHOW_COMMEMORATE, SHOW_RIBBON } from 'src/constants';
import { APP_IMG } from 'src/constants/index';
import { IExpandToggle } from 'src/interface/layout';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { getWidthDimension, splitRote } from 'src/utils/helper';

const CardVNav = dynamic(import('src/components/cards/card-v-nav'));
// const WidgetSearchFullPage = dynamic(import('src/components/widget/widget-search-full-page'));
// const WidgetLogin = dynamic(import('src/services/member-auth/components/widget-login'));

type Props = {
  _data: any;
  eventDataLayer: any;
};

const NavDesktop: NextPage<Props> = ({ eventDataLayer, _data }) => {
  const moreMenuRef: any = useRef();
  const [moreMenu, setMoreMenu] = useState(true);
  // ---------- expand sub-menu ----------
  const [subToggleMoreMenu, setSubToggleMoreMenu] = useState<IExpandToggle>({
    status: false,
    key: null
  });

  const [subToggle, setSubToggle] = useState<IExpandToggle>({
    status: false,
    key: null
  });
  const [widthDimension, setWidthDimension] = useState(getWidthDimension());
  const router: NextRouter = useRouter();

  const cid: string = router.asPath;
  const queryCid: string | string[] | undefined = router.query.cid;
  const [articles, setArticles]: any = useState({
    key: null,
    data: null,
    link: null
  });

  const closeTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const closeMoreMenuTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // ฟังก์ชันสำหรับ side-nav-menu
  const handleMouseEnter = (index: number, element: any) => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setSubToggle({ status: true, key: index });
    setArticles({
      key: index,
      data: element?.sub[0]?.data,
      link: element?.sub[0]?.link
    });
  };

  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setSubToggle({ status: false, key: null });
    }, 150);
  };

  // ฟังก์ชันสำหรับ expand-more-menu
  const handleMoreMenuMouseEnter = (index: number, element: any) => {
    if (closeMoreMenuTimeoutRef.current) {
      clearTimeout(closeMoreMenuTimeoutRef.current);
      closeMoreMenuTimeoutRef.current = null;
    }
    setSubToggleMoreMenu({ status: true, key: index });
    setArticles({
      key: index,
      data: element?.sub[0]?.data,
      link: element?.sub[0]?.link
    });
  };

  const handleMoreMenuMouseLeave = () => {
    closeMoreMenuTimeoutRef.current = setTimeout(() => {
      setSubToggleMoreMenu({ status: false, key: null });
    }, 150);
  };

  let _results: any = [];
  let _dataArray = Array.isArray(_data) ? [..._data] : [];

  if (widthDimension?.width < 1000) {
    _results = _dataArray.splice(0, 4);
  } else if (widthDimension?.width < 1250) {
    _results = _dataArray.splice(0, 7);
  } else {
    _results = _dataArray.splice(0, 8);
  }

  _data = _dataArray;
  useEffect(() => {
    function handleResize() {
      setWidthDimension(getWidthDimension());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [router.isReady]);

  return (
    <>
      <NavWrapper className='nav-desktop'>
        <SideBarWrapper id='side-bar'>
          <ul className='side-nav-menu' id='side-nav-menu' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset', zIndex: 10 }}>
            {/* <li className={`${cid === '/' ? '--active' : ''} listItem`}>
              <a
                href={`${splitRote(router)}/`}
                aria-label='nav-desktop'
                title='หน้าแรก'
                // ! DATALAYER
                onClick={() =>
                  sendDataLayerGlobal({
                    ...eventDataLayer,
                    data: {
                      title: 'หน้าแรก',
                      heading: 'หน้าแรก'
                    }
                  })
                }
              >
                <span> หน้าแรก </span>
              </a>
            </li> */}
            {!isEmpty(_results) &&
              _results?.map((element: any, index: any) => (
                <li className={`${cid === `/${element?.link}` || queryCid === element?.nameEng ? '--active' : ''} listItem`} key={index} onMouseLeave={handleMouseLeave}>
                  <a
                    href={`${splitRote(router)}/${element?.link}`}
                    onMouseOver={() => handleMouseEnter(index, element)}
                    onFocus={() => {}}
                    title={element?.nameTh}
                    aria-label={element?.nameTh}
                    // ! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        ...eventDataLayer,
                        data: {
                          title: element?.nameTh,
                          heading: element?.nameTh,
                          index: index + 2
                        }
                      })
                    }
                  >
                    <span>{element?.nameTh}</span>
                    {element.sub.length > 0 && <FaAngleDown size={14} />}
                  </a>
                  {subToggle?.key === index && subToggle?.status && element?.sub.length > 0 && (
                    <div
                      className='nav-sub-menu --left'
                      onMouseEnter={() => {
                        // ← เพิ่ม onMouseEnter
                        if (closeTimeoutRef.current) {
                          clearTimeout(closeTimeoutRef.current);
                          closeTimeoutRef.current = null;
                        }
                      }}
                      onMouseLeave={handleMouseLeave}
                    >
                      <CardSubMenuStyle>
                        <div className='card-sub-menu'>
                          <div className='block-1'>
                            <ul>
                              {!isEmpty(element?.sub) &&
                                element.sub.map((subMenu: any, i: any) => (
                                  <li
                                    key={i}
                                    aria-hidden='true'
                                    onMouseOver={() => {
                                      setArticles({
                                        key: i,
                                        data: subMenu?.data,
                                        link: subMenu?.link
                                      });
                                    }}
                                    onFocus={() => {}}
                                  >
                                    <a
                                      href={`${splitRote(router)}${subMenu?.link}`}
                                      title={subMenu.nameTh}
                                      // ! DATALAYER
                                      onClick={() =>
                                        sendDataLayerGlobal({
                                          ...eventDataLayer,
                                          position: 'ใน:menubar',
                                          data: {
                                            title: subMenu?.nameTh,
                                            heading: `${element?.nameTh}:${subMenu?.nameTh}`,
                                            index: i + 1
                                          }
                                        })
                                      }
                                    >
                                      {subMenu?.nameTh}
                                    </a>
                                  </li>
                                ))}
                            </ul>
                          </div>
                          <div className='block-2'>
                            {!isEmpty(articles?.data) ? (
                              <>
                                <div className='card-list'>
                                  {articles.data.slice(0, 6).map((item: any, i: any) => (
                                    <div key={i} className={`card-item item-${i + 1}`}>
                                      <CardVNav
                                        data={item}
                                        showBlurb={false}
                                        showBadge={false}
                                        showCountView={false}
                                        // ! DATALAYER
                                        eventDataLayer={{
                                          ...eventDataLayer,
                                          position: 'ใน:menubar',
                                          data: {
                                            heading: `${element?.nameTh}:${element.sub[i]?.nameTh}`
                                          }
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                                <div className='btn-readmore'>
                                  <a className='see-all' href={articles?.link} title='see all'>
                                    {'>>> ดูทั้งหมด'}
                                  </a>
                                </div>
                              </>
                            ) : (
                              <div className='empty'>
                                <img className='logo-img' src={`${APP_IMG}/default.jpg`} loading='lazy' alt='logo-mobile' title='logo-mobile' width='50%' height='auto' />
                              </div>
                            )}
                          </div>
                        </div>
                      </CardSubMenuStyle>
                    </div>
                  )}
                </li>
              ))}
          </ul>
          <div className='area-more-menu'>
            {_data.length > 0 && (
              <>
                <ul className='more-menu' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
                  {_results.length > 0 &&
                    (moreMenu ? (
                      <li onClick={() => setMoreMenu(false)}>
                        <FaGripHorizontal size={24} style={{ filter: SHOW_RIBBON === 'true' ? 'grayscale(0.7)' : 'unset' }} />
                      </li>
                    ) : (
                      <li onClick={() => setMoreMenu(true)}>
                        <FaTimes size={18} style={{ filter: SHOW_RIBBON === 'true' ? 'grayscale(0.7)' : 'unset' }} />
                      </li>
                    ))}
                </ul>

                <div className={`expand-more-menu ${moreMenu ? '--hide' : ''}`} ref={moreMenuRef} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
                  <ul className='expand-nav-menu'>
                    {_data.map((element: any, i: any) => (
                      <li key={i} className={`${cid === `/${element?.link}` || queryCid === element?.nameEng ? '--active' : ''} listItem`}>
                        {element.sub.length > 0 ? (
                          <div className='item-menu' key={i} onMouseOver={() => handleMoreMenuMouseEnter(i, element)} onMouseLeave={handleMoreMenuMouseLeave}>
                            <a
                              href={`${splitRote(router)}/${element?.link}`}
                              // ! DATALAYER
                              onClick={() =>
                                sendDataLayerGlobal({
                                  ...eventDataLayer,
                                  position: 'ใน:expanded-menubar',
                                  data: {
                                    title: element?.nameTh,
                                    heading: `${element?.nameTh}`,
                                    index: i + 1
                                  }
                                })
                              }
                            >
                              <span> {element.nameTh}</span>
                            </a>
                            {element.sub.length > 0 && <FaAngleDown size={14} />}
                            {subToggleMoreMenu.status && subToggleMoreMenu.key === i && (
                              // {true && (
                              <div
                                className='nav-sub-menu --left'
                                onMouseEnter={() => {
                                  if (closeMoreMenuTimeoutRef.current) {
                                    clearTimeout(closeMoreMenuTimeoutRef.current);
                                    closeMoreMenuTimeoutRef.current = null;
                                  }
                                }}
                                onMouseLeave={handleMoreMenuMouseLeave}
                              >
                                <CardSubMenuStyle>
                                  <div className='card-sub-menu'>
                                    <div className='block-1'>
                                      <ul>
                                        {!isEmpty(element?.sub) &&
                                          element.sub.map((subMenu: any, i: any) => (
                                            <li
                                              key={i}
                                              aria-hidden='true'
                                              onMouseOver={() => {
                                                setArticles({
                                                  key: i,
                                                  data: subMenu?.data,
                                                  link: subMenu?.link
                                                });
                                              }}
                                              onFocus={() => {}}
                                            >
                                              <a
                                                href={`${splitRote(router)}${subMenu?.link}`}
                                                title={subMenu.nameTh}
                                                // ! DATALAYER
                                                onClick={() =>
                                                  sendDataLayerGlobal({
                                                    ...eventDataLayer,
                                                    position: 'ใน:expanded-menubar',
                                                    data: {
                                                      title: subMenu?.nameTh,
                                                      heading: `${element?.nameTh}:${subMenu?.nameTh}`,
                                                      index: i + 1
                                                    }
                                                  })
                                                }
                                              >
                                                {subMenu?.nameTh}
                                              </a>
                                            </li>
                                          ))}
                                      </ul>
                                    </div>
                                    <div className='block-2'>
                                      {!isEmpty(articles?.data) ? (
                                        <>
                                          <div className='card-list'>
                                            {articles.data.slice(0, 6).map((item: any, i: any) => (
                                              <div key={i} className={`card-item item-${i + 1}`}>
                                                <CardVNav
                                                  data={item}
                                                  showBlurb={false}
                                                  showBadge={false}
                                                  showCountView={false}
                                                  // ! DATALAYER
                                                  eventDataLayer={{
                                                    ...eventDataLayer,
                                                    position: 'ใน:menubar',
                                                    data: {
                                                      heading: `${element?.nameTh}:${element.sub[i]?.nameTh}`
                                                    }
                                                  }}
                                                />
                                              </div>
                                            ))}
                                          </div>
                                          <div className='btn-readmore'>
                                            <a className='see-all' href={articles?.link} title='see all'>
                                              {'>>> ดูทั้งหมด'}
                                            </a>
                                          </div>
                                        </>
                                      ) : (
                                        <div className='empty'>
                                          <img className='logo-img' src={`${APP_IMG}/default.jpg`} loading='lazy' alt='logo-mobile' title='logo-mobile' width='50%' height='auto' />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </CardSubMenuStyle>
                              </div>
                            )}
                          </div>
                        ) : (
                          <a
                            href={`${splitRote(router)}/${element?.link}`}
                            // ! DATALAYER
                            onClick={() =>
                              sendDataLayerGlobal({
                                ...eventDataLayer,
                                position: 'ใน:expanded-menubar',
                                data: {
                                  title: element?.nameTh,
                                  heading: `${element?.nameTh}`,
                                  index: i + 1
                                }
                              })
                            }
                          >
                            {element?.nameTh}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            )}
            {/* <WidgetSearchFullPage /> */}
            {/* <WidgetLogin sessionSevId={sessionSevId} /> */}
          </div>
        </SideBarWrapper>
      </NavWrapper>
    </>
  );
};
const NavWrapper = styled.div`
  position: relative;
  /* max-width: 1300px; */
  margin: auto;
  .area-more-menu {
    display: flex;
    align-items: center;
    .more-menu {
      padding: 12px;
      min-width: 48px;
      @media (max-width: 1024px) {
        display: none;
      }
      li {
        display: flex;
        align-items: center;
        color: rgb(220 21 53);
        &:hover svg {
          color: #ed1a3b;
        }
      }
      svg {
        cursor: pointer;
        color: #fff;
        height: 24px;
        width: 24px;
      }
    }
  }
  .expand-more-menu {
    position: absolute;
    top: 48px;
    left: 0px;
    width: 100%;
    background-color: transparent;
    /* box-shadow: 0px 5px 6px -6px rgba(0, 0, 0, 0.3); */
    padding: 0px;
    z-index: 5;
    min-height: 46px;
    @media (max-width: 1024px) {
      display: none;
    }
    .expand-nav-menu {
      li > div,
      .listItem {
        .item-menu {
          display: flex;
          align-items: center;
          padding: 0px 12px;
        }
        a {
          color: #ffffff;
          font-weight: 500;
          text-transform: uppercase;
          font-size: 16px;
        }
        svg {
          color: #ffffff;
          margin-left: 5px;
          margin-bottom: 0px;
          vertical-align: middle;
        }

        &:hover {
          span {
            border-bottom: 2px solid #ed1a3b;
          }
          a,
          svg {
            color: #ed1a3b;
          }
        }
      }

      padding: 5px 0;
    }

    ul {
      /* max-width: 1223px; */
      /* margin: auto; */
      display: flex;
      justify-content: space-between;
      width: 100%;
      flex-direction: unset;
      list-style-type: none;
      position: relative;
      gap: 15px;
    }

    &.--hide {
      display: none;
    }
  }
`;
const CardSubMenuStyle = styled.div`
  position: relative;
  align-items: center;
  .card-sub-menu {
    background-color: #000;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-areas: 'block-1 block-2 block-2 block-2 block-2 block-2';
    grid-gap: 20px;
    padding: 20px;
    .block-1 {
      grid-area: block-1;
      ul {
        flex-direction: column !important;
        flex-wrap: unset !important;
      }
      ul li a {
        font-size: 16px !important;
        color: #fff !important;
        &:hover {
          color: rgb(220 21 53) !important;
        }
      }
    }
    .block-2 {
      grid-area: block-2;

      .empty {
        text-align: center;
      }
      .card-list {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 20px;
        .card-item {
          &:hover {
            h3 {
              color: rgb(220 21 53) !important;
            }
          }
        }
        .card-content {
          padding: 0px;
          h3 {
            color: #fff;
            line-height: 1.55;
          }
        }
      }
      .btn-readmore {
        width: 100%;
        text-align: right;
        margin-top: 10px;
        a {
          font-size: 16px !important;
          color: #fff;
          &:hover {
            color: rgb(220 21 53) !important;
          }
        }
      }
    }
    ul {
      flex-direction: column;
      overflow-y: scroll !important;
      height: 600px;
      list-style: none;
      padding: 0;
      display: block;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        background-color: rgba(247, 247, 247, 0.9);
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 50px;
        background-color: rgb(220 21 53);
      }

      li {
        padding: 5px;
        border-radius: 15px;
        margin-bottom: 16px;
        margin-left: 0px;
        text-align: left;
        border: 2px;
        /* color: var(--primary-color); */
        transition: all 0.3s ease-out;
        /* a {
          color: var(--primary-color);
        } */
        /* a {
          color: var(--primary-color);
          text-transform: capitalize;
          font-weight: 400;
          &:hover {
            padding-left: 16px;
            color: #333;
          }
        } */

        i {
          float: right;
          color: transparent;
        }
        /* &:hover {
          padding-left: 16px;
          color: var(--primary-color);
          border: unset;
          i {
            color: var(--primary-color);
          }
        } */
        a {
          color: var(--primary-color);
        }
        &:hover {
          padding-left: 16px;
        }
      }
    }
  }
`;

const SideBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .side-nav-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .svg-tag {
      cursor: pointer;
      color: var(--primary-color);
      width: 30px;
      height: 30px;
      path {
        stroke: var(--primary-color);
      }
    }
  }
  .side-nav-menu {
    @media (max-width: 1024px) {
      display: none;
    }
    position: relative;
    list-style: none;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    transition: opacity 1s ease-in-out;

    li.listItem {
      /* position: relative;  */
      display: flex;
      align-items: center;
      padding: 0px 12px;
      /* height: 54px; */

      .nav-sub-menu {
        position: absolute;
        top: 30px;
        overflow: visible;
        a {
          font-weight: 500;
          font-size: 16px;
          color: #fff;
          &:hover {
            color: #ed1a3b;
          }
        }
      }
      span {
        text-transform: uppercase;
        font-size: 16px;
        color: #ffffff;
        font-weight: 500;
        vertical-align: middle;
      }
      svg {
        vertical-align: middle;
        color: #ffffff;
        margin-left: 5px;
        @media (max-width: 960px) {
          display: none;
        }
      }

      &:hover {
        z-index: 7;
        span {
          border-bottom: 2px solid #ed1a3b;
        }
        span,
        svg {
          color: #ed1a3b;
        }
      }
      &.--active {
        span,
        svg {
          color: #ffffff;
        }
      }
    }
  }
  .nav-sub-menu {
    background: #000;
    width: 1000px;
    position: absolute;
    visibility: visible;
    top: 37px;
    z-index: 5;
    padding: 0px;
    margin: 0;
    opacity: 1;
    transition: all 0.3s ease-out;
    transform-origin: 0 0 0;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    @media (min-width: 1300px) {
      width: 1300px;
    }
    a {
      display: block;
      transition: all 0.5s ease-out;
    }
    &.--left {
      left: 0px;
    }
  }
`;
export default NavDesktop;
